module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.2a61b00.eot";